import GlobalQuickJump from "../../../../../global/GlobalQuickJump";

export default function TournamentQuickJumpSection(props) {
  return <GlobalQuickJump {...props} />;
}
